import { axiosInstanceConversationalEngine, axiosInstanceWebsite } from "../../instance";
import { AxiosResponse } from "../../interface";
import { postGenerateComplementaryProductInterface, ProductRecommendation, UploadFileToS3Data } from "./generateCopysAxioxinterface";
// import { FormDataProduct } from "../../../components/forms/FormWebsiteConfiguration/FormWebsiteConfigurationInterface";

export const postCopys = async (data: any) => {
  data.productDescription = data.productDetails;
  const response: AxiosResponse = await axiosInstanceWebsite.post(
    "/websites",
    data
  );
  
  return response.data;
};

export const getLastCopyByUserId = async (
  userId: string,
  websiteUuid: string
) => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(
    `/websites/${websiteUuid}`,
    {
      headers: {
        "Content-Type": "application/json",
        // "owner-id": userId,
      },
    }
  );
  return response.data;
};

// export const postUploadFileToS3 = async (data: UploadFileToS3Data) => {
//   const formData = new FormData();

//   formData.append("userId", data.userId);
//   formData.append("websiteId", data.websiteId);
//   formData.append("index", data.html);
//   formData.append("css", data.css);
//   formData.append("js", data.js);
//   formData.append("upSell", data.upSell);
//   formData.append("downSell", data.downSell);
//   formData.append("thankYou", data.thankYou);
//   formData.append("content", data.content);

//   const response: AxiosResponse = await axiosInstance.post(
//     "/s3-bucket/upload-file-to-s3",
//     formData,
//     {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     }
//   );
//   return response.data;
// };

export const getListOfFunnels = async () => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(`/websites/summary`, {
    headers: {
      "Content-Type": "application/json",
      // "owner-id": userId,
    },
  });
  return response.data;
};
export const getListOfFiles = async () => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(`/websites`, {
    headers: {
      "Content-Type": "multipart/form-data",
      // "owner-id": userId,
    },
  });
  return response.data;
};

export const deleteWebsite = async (userId: string, websiteId: string) => {
  const response: AxiosResponse = await axiosInstanceWebsite.delete(`/websites/${websiteId}`, {
    headers: {
      "Content-Type": "multipart/form-data",
      // "owner-id": userId,
    },
  });
  return response.data;
};

export const postGenerateComplementaryProduct = async (
  data: postGenerateComplementaryProductInterface
): Promise<ProductRecommendation> => {
  const response: AxiosResponse = await axiosInstanceConversationalEngine.post(
    `/recommend-product`,
    data
  );
  return response.data;
};
